import React, { useEffect, useState } from "react";
import { useAppDispatch } from "app/store";
import { Navigate, useNavigate, useParams } from "react-router";
import userService from "@fuse/services/userService";
import { IApiResponse, IUserData } from "@fuse/models/user.models";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MobileDetect from "mobile-detect";
import { Card, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { Link } from "react-router-dom";
import adminService from "@fuse/services/adminService";
import FuseLoading from "@fuse/core/FuseLoading";

function StripeSearchResultsView() {
	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};

	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const params = useParams();
	const searchkey = params.searchkey;
	const [userDataList, setUserDataList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [noDataFoundMessage, setNoDataFoundMessage] = useState("");

	const md = new MobileDetect(window.navigator.userAgent);
	const isMobile = md.mobile();
	const theme = useTheme();

	const columns = [
		{ id: "last4", label: "Card Last 4 Digits" },
		{ id: "created", label: "Created" },
		{ id: "name", label: "Name" },
		{ id: "email", label: "Email" },
		{ id: "amount", label: "Amount" },
		{ id: "currency", label: "Currency" },
		{ id: "status", label: "Payment Status" },
	];
	useEffect(() => {
		if (searchkey)
			adminService
				.searchStripeTransactions(searchkey)
				.then((res: IApiResponse) => {
					setLoading(false);
					if (res.succeeded) {
						setUserDataList(res.result);
					}

					if (res.succeeded && res.result.length === 0) {
						setNoDataFoundMessage("No records found");
					}
				});
	}, [searchkey]);
	return (
		<>
			<div className="w-full p-[20px]">
				<div className="flex flex-col gap-[20px]">
					<Card className="p-[28px] overflow-hidden">
						<div className="flex flex-wrap w-full items-center px-8 py-12 md:px-16 border-b">
							<div className="flex flex-col flex-auto my-12 mx-8">
								<div className="flex items-center space-x-8">
									<motion.div
										initial={{ x: 20, opacity: 0 }}
										animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
									>
										<Typography
											className="flex items-center sm:mb-12"
											component={Link}
											role="button"
											to="/admin-dashboard"
											color="inherit"
										>
											<FuseSvgIcon size={20}>
												{theme.direction === "ltr"
													? "heroicons-outline:arrow-sm-left"
													: "heroicons-outline:arrow-sm-right"}
											</FuseSvgIcon>
											<Typography className="flex mx-4 font-700 text-2xl">
												Stripe Payment Records
											</Typography>
										</Typography>
										<Typography
											className="flex items-center sm:mb-12"
											role="button"
											color="inherit"
										></Typography>
									</motion.div>
								</div>
							</div>
						</div>
						<TableContainer component={Paper} sx={{ maxHeight: 580 }}>
							<Table stickyHeader aria-label="Search results">
								<TableHead>
									<TableRow>
										{columns.map((column) => (
											<TableCell className="font-700 bg-white" key={column.id}>
												{column.label}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{userDataList.map((user) => (
										<TableRow key={user.paymentIntentId}>
											{columns.map((column) => (
												<TableCell
													className="font-400 cursor-default"
													key={column.id}
												>
													{user[column.id]}
												</TableCell>
											))}
										</TableRow>
									))}
								</TableBody>
							</Table>
								{loading && (
									<motion.div
										className="flex w-full gap-24 min-w-0 p-48"
										variants={container}
										initial="hidden"
										animate="show"
									>
										<FuseLoading />
									</motion.div>
								)}
								{noDataFoundMessage && (
									<motion.div
										className="flex w-full gap-24 min-w-0 p-24"
										variants={container}
										initial="hidden"
										animate="show"
									>
										{noDataFoundMessage}
									</motion.div>
								)}
						</TableContainer>
					</Card>
				</div>
			</div>
		</>
	);
}

export default StripeSearchResultsView;
